import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { RichText } from '../components/RichText';
import { company } from '../data/company';
import { policies } from '../data/policies';
const order = ['privacy', 'terms', 'delivery', 'refund'] as const;
export function Policies() {
  return <>
      <PageHeader title="Policies" intro="Our Privacy Policy, Terms of Service, Digital Delivery Policy, and Refund Policy in one place." data-id="element-198" data-mp="2x6ouj7440w5w">
        <p className="mt-6 text-sm text-muted" data-id="element-199" data-mp="3owtckz4ed73y">
          Last updated: <RichText text={company.lastUpdated} data-id="element-200" data-mp="3k4telc7w0oa0" />
        </p>
      </PageHeader>

      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-14 sm:px-8 lg:grid-cols-[220px_1fr]" data-id="element-201" data-mp="3k2p0k1g9y8w0">
        <aside className="hidden lg:block" data-id="element-202" data-mp="3g1nbgdg2nd7r">
          <nav aria-label="Policies" className="sticky top-24" data-id="element-203" data-mp="gg8be4i0bibe">
            <h2 className="text-sm font-semibold text-ink" data-id="element-204" data-mp="bp9rkuxt823e">On this page</h2>
            <ul className="mt-3 space-y-2 border-l border-line" data-id="element-205" data-mp="bn5cdgugngnt">
              {order.map(key => <li key={key} data-id="element-206" data-mp="1qseehcmmdevc">
                  <Link to={`/policies#${key}`} className="-ml-px block border-l border-transparent pl-4 text-sm text-muted transition-colors duration-150 hover:border-accent hover:text-ink" data-id="element-207" data-mp="1vp4szvis02en">
                    {policies[key].title}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </aside>

        <div className="max-w-3xl" data-id="element-208" data-mp="1czg3ihxp1e6o">
          {order.map(key => {
          const policy = policies[key];
          return <article key={key} id={key} aria-labelledby={`${key}-title`} className="scroll-mt-20 border-b border-line py-14 last:border-b-0" data-id="element-209" data-mp="y2xosmqdwc2t">
                <h2 id={`${key}-title`} className="font-serif text-3xl font-semibold tracking-tight text-ink" data-id="element-210" data-mp="2sfnkna0bbvcu">{policy.title}</h2>
                <p className="mt-3 text-lg leading-relaxed text-muted" data-id="element-211" data-mp="2xf09g0aqvci2">{policy.summary}</p>
                <div className="mt-8 space-y-8" data-id="element-212" data-mp="2vy4btkhyyeth">
                  {policy.sections.map(s => <section key={s.id} id={`${key}-${s.id}`} className="scroll-mt-20" data-id="element-213" data-mp="2qxyp8iqk3ii9">
                      <h3 className="text-lg font-semibold text-ink" data-id="element-214" data-mp="2lz58mhfz3bdv">{s.heading}</h3>
                      {s.paragraphs?.map((p, i) => <p key={i} className="mt-2 leading-relaxed text-muted" data-id="element-215" data-mp="2hz4u6wsvj06t">
                          <RichText text={p} data-id="element-216" data-mp="3en14jjxpwz9l" />
                        </p>)}
                      {s.list && <ul className="mt-2 list-disc space-y-2 pl-5 leading-relaxed text-muted marker:text-accent" data-id="element-217" data-mp="39prgo8pz8vnv">
                          {s.list.map((item, i) => <li key={i} data-id="element-218" data-mp="30vwcp40ldb9t" data-mpi={i}>
                              <RichText text={item} data-id="element-219" data-mp="30uuzou00mepg" />
                            </li>)}
                        </ul>}
                    </section>)}
                </div>
              </article>;
        })}

          <section aria-labelledby="policy-contact" className="rounded-xl bg-canvas p-6" data-id="element-220" data-mp="1f726uk31puav">
            <h2 id="policy-contact" className="font-serif text-xl font-semibold text-ink" data-id="element-221" data-mp="1k4kfe9d5i7ic">Questions about these policies?</h2>
            <p className="mt-2 leading-relaxed text-muted" data-id="element-222" data-mp="1o88mkqxvf132">
              Contact {company.legalName} at <RichText text={company.email} data-id="element-223" data-mp="1t2may9e487y8" />, or use our{' '}
              <Link to="/#contact" className="font-medium text-accent underline-offset-4 hover:underline" data-id="element-224" data-mp="1y3adnsbpid8a">contact form</Link>.
            </p>
            <p className="mt-2 text-sm text-muted" data-id="element-225" data-mp="230tqqowo4jyn">
              Mailing address: <RichText text={company.address} data-id="element-226" data-mp="27uenyeqft9ws" />
            </p>
          </section>
        </div>
      </div>
    </>;
}